function ConditionStatementController(stateService, eventService) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.types = [
      { type: 'User variable', id: 0 },
      { type: 'Truth value', id: 2 },
      { type: 'Date/Time', id: 3 },
    ];
    
    ctrl.brackets = [1,2,3,4,5];

    if (!ctrl.newBlock) {
      ctrl.newBlock = {
        dates: [null],
        years: [null],
        weekdays: [null],
        minutes: [null],
        minutesBetween: [null],
        notOperation: false,
      };
    } else {
      ctrl.newBlock.dates = [null];
      ctrl.newBlock.years = [null];
      ctrl.newBlock.weekdays = [null];
      ctrl.newBlock.minutes = [null];
      ctrl.newBlock.minutesBetween = [null];
      ctrl.newBlock.startBrackets = [];
      ctrl.newBlock.endBrackets = [];
      ctrl.newBlock.notOperation = false;
    }

    ctrl.weekdays = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ];

    ctrl.hstep = 1;
    ctrl.mstep = 1;

    ctrl.operators = [
      {
        special: true,
        value: '=='
      },
      {
        special: true,
        value: '!='
      },
      {
        special: true,
        value: '/=='
      },
      {
        special: true,
        value: '\\=='
      },
      {
        special: false,
        value: '>'
      },
      {
        special: false,
        value: '/>'
      },
      {
        special: false,
        value: '\\>'
      },
      {
        special: false,
        value: '>='
      },
      {
        special: false,
        value: '/>='
      },
      {
        special: false,
        value: '\\>='
      },
      {
        special: false,
        value: '<'
      },
      {
        special: false,
        value: '/<'
      },
      {
        special: false,
        value: '\\<'
      },
      {
        special: false,
        value: '<='
      },
      {
        special: false,
        value: '/<='
      },
      {
        special: false,
        value: '\\<='
      },
      {
        special: true,
        value: '/!='
      },
      {
        special: true,
        value: '\\!='
      },
    ];

    ctrl.truthValues = ['TRUE', 'FALSE'];
    ctrl.boolOrInt = ['Boolean', 'Number'];

    ctrl.dateTimes = [
      { name: 'Minutes', code: 'MINUTE' },
      { name: 'Minutes Between', code: 'MINUTE_BETWEEN' },
      { name: 'Date', code: 'DATE' },
      { name: 'Date Between', code: 'DATE_BETWEEN' },
      { name: 'Date Time Between', code: 'DATE_TIME_BETWEEN' },
      { name: 'Day of week', code: 'DAY_OF_WEEK' },
      { name: 'Time Between', code: 'TIME_BETWEEN' },
      { name: 'Weekday', code: 'WEEKDAY' },
      { name: 'Weekend', code: 'WEEKEND' },
      { name: 'Year', code: 'YEAR' },
    ];

    if (ctrl.viewMode) {
      ctrl.editMode = false;
    } else {
      ctrl.editMode = true;
    }

    ctrl.optionsMenu = {
      startDateOpened: false,
      endDateOpened: false,
      pickersOpen: [],
      openDatePicker: function($event, index) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.pickersOpen[index] = true;
      },
      datePickerFormat: 'dd.MM.yyyy',
      yearPickerFormat: 'yyyy',
      dateOptions: {
        startingDay: 1,
        showWeeks: false,
      },
      yearOptions: {
        datepickerMode: 'year',
        minMode: 'year',
        showWeeks: 'false',
      }
    };
    ctrl.datePickers = [];
  };

  ctrl.addDatePicker = () => {
    ctrl.newBlock.dates.push(null);
  };

  ctrl.addYearPicker = () => {
    ctrl.newBlock.years.push(null);
  };

  ctrl.addDayPicker = () => {
    ctrl.newBlock.weekdays.push(null);
  };

  ctrl.addMinutePicker = () => {
    ctrl.newBlock.minutes.push(null);
  };

  ctrl.addMinutesBetweenPicker = () => {
    ctrl.newBlock.minutesBetween.push(null);
  };

  ctrl.removeBlock = function() {
    ctrl.onRemove({
      $event: {
        blockIndex: ctrl.index,
      },
    });
  };

  ctrl.removeDate = (index, type) => {
    ctrl.newBlock[type].splice(index, 1);
  };

  ctrl.addBracket = value => {
    if (value === 'start') {
      eventService.broadcast('start-bracket-picked', ctrl.bracketMode);
      ctrl.newBlock.startBrackets.push(ctrl.bracketMode);
    } else if (value === 'end') {
      eventService.broadcast('end-bracket-picked', ctrl.bracketMode);
      ctrl.newBlock.endBrackets.push(ctrl.bracketMode);
    }
  };

  ctrl.resetOperator = () => {
    ctrl.operatorChoice = null;
  };

  ctrl.saveBlock = function() {
    ctrl.editMode = false;
    ctrl.onSave({
      $event: {
        blockIndex: ctrl.index,
        newBlock: ctrl.newBlock,
      },
    });
  };

  ctrl.enableEdit = function() {
    ctrl.editMode = true;
    ctrl.onEdit();
  };
}

angular
  .module('pis-tool.module')
  .controller('ConditionStatementController', ConditionStatementController);
